import type { ComponentChildren } from "preact";

interface ButtonProps {
  text: string;
  icon?: string;
  iconPosition?: "left" | "right";
  disabled?: boolean;
  loading?: boolean;
  type?: "button" | "submit";
  onClick?: () => void;
}

function renderInner(props: ButtonProps): ComponentChildren {
  if (props.loading) {
    return <span class="tl-btn__spinner" aria-hidden="true" />;
  }
  const iconPosition = props.iconPosition ?? "right";
  const ico = props.icon ? (
    <span class="material-icons" aria-hidden="true">
      {props.icon}
    </span>
  ) : null;
  return (
    <>
      {iconPosition === "left" && ico}
      <span>{props.text}</span>
      {iconPosition === "right" && ico}
    </>
  );
}

export function PrimaryButton(props: ButtonProps) {
  const { disabled, loading, type = "button", onClick } = props;
  return (
    <button
      class="tl-btn tl-btn--primary"
      type={type}
      disabled={disabled || loading}
      aria-busy={loading || undefined}
      onClick={onClick}
    >
      {renderInner(props)}
    </button>
  );
}

export function SecondaryButton(props: ButtonProps) {
  const { disabled, loading, type = "button", onClick } = props;
  return (
    <button
      class="tl-btn tl-btn--secondary"
      type={type}
      disabled={disabled || loading}
      aria-busy={loading || undefined}
      onClick={onClick}
    >
      {renderInner(props)}
    </button>
  );
}

export function TextButton(props: ButtonProps) {
  const { disabled, loading, type = "button", onClick } = props;
  return (
    <button
      class="tl-btn tl-btn--text"
      type={type}
      disabled={disabled || loading}
      aria-busy={loading || undefined}
      onClick={onClick}
    >
      {renderInner(props)}
    </button>
  );
}
